// firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDxHFYZ4Gpg4Tz-MjhZr9WuczizuxYhSSM",
  authDomain: "webstore-250d6.firebaseapp.com",
  databaseURL: "https://webstore-250d6-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "webstore-250d6",
  storageBucket: "webstore-250d6.appspot.com",
  messagingSenderId: "272331288260",
  appId: "1:272331288260:web:12c0ad391f63091cbea391"
};

// ✅ Initialize once
const app = initializeApp(firebaseConfig);

// ✅ Create shared instances
const auth = getAuth(app);
const db = getFirestore(app);
const rtdb = getDatabase(app); // ✅ Use this form only ONCE here
const storage = getStorage(app);

export { app, auth, db, rtdb, storage };
